<script setup lang="ts">
const localePath = useLocalePath();
const year = new Date().getFullYear();

const prepLinks = [
  { label: "Paper Pattern", to: "/11th/computer/paper-pattern/" },
  { label: "Pairing Scheme", to: "/11th/computer/pairing-scheme/" },
  { label: "Important Questions", to: "/11th/computer/important-questions/" },
  { label: "MCQs", to: "/11th/computer/mcqs/top-100/" },
];

const siteLinks = [
  { label: "Site Map", to: "/site-map/" },
  { label: "Contact", to: "/contact/" },
  { label: "Privacy", to: "/privacy/" },
  { label: "Terms", to: "/terms/" },
  { label: "Disclaimer", to: "/disclaimer/" },
];
</script>

<template>
  <footer class="mt-20 border-t border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900">
    <div class="mx-auto grid max-w-7xl gap-8 px-6 py-10 md:grid-cols-3">
      <div>
        <p class="mb-2 text-lg font-semibold text-slate-900 dark:text-white">Ustaad</p>
        <p class="text-sm leading-6 text-slate-600 dark:text-slate-400">
          Ustaad students ke liye exam-focused study platform hai jahan paper pattern,
          pairing scheme, important questions, MCQs aur chapter-wise prep aik jagah milti hai.
        </p>
      </div>

      <div>
        <p class="mb-2 text-sm font-semibold uppercase tracking-[0.18em] text-slate-900 dark:text-white">
          Main Study Links
        </p>
        <ul class="space-y-2 text-sm">
          <li><NuxtLink :to="localePath('/11th/computer/')" class="text-slate-700 hover:underline dark:text-slate-300">11th Computer</NuxtLink></li>
          <li><NuxtLink :to="localePath('/11th/computer/python/')" class="text-slate-700 hover:underline dark:text-slate-300">Python</NuxtLink></li>
          <li><NuxtLink :to="localePath('/11th/english/')" class="text-slate-700 hover:underline dark:text-slate-300">11th English</NuxtLink></li>
          <li><NuxtLink :to="localePath('/11th/english/grammar/')" class="text-slate-700 hover:underline dark:text-slate-300">English Grammar</NuxtLink></li>
        </ul>
      </div>

      <div>
        <p class="mb-2 text-sm font-semibold uppercase tracking-[0.18em] text-slate-900 dark:text-white">
          Important Prep Links
        </p>
        <ul class="space-y-2 text-sm">
          <li v-for="link in prepLinks" :key="link.to">
            <NuxtLink :to="localePath(link.to)" class="text-slate-700 hover:underline dark:text-slate-300">{{ link.label }}</NuxtLink>
          </li>
        </ul>
      </div>
    </div>

    <div class="border-t border-slate-200 px-6 py-4 dark:border-slate-800">
      <div class="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-slate-500 dark:text-slate-400">
        <NuxtLink
          v-for="link in siteLinks"
          :key="link.to"
          :to="localePath(link.to)"
          class="transition hover:text-slate-700 dark:hover:text-slate-200"
        >
          {{ link.label }}
        </NuxtLink>
      </div>
      <div class="mt-3 text-center text-xs text-slate-500 dark:text-slate-400">
        &copy; {{ year }} Ustaad. All rights reserved.
      </div>
    </div>
  </footer>
</template>
